<template>
  <div>
    <div class="page-title-container lighter-shadow">
      <i class="fa fa-user icon"></i>
      <h1 v-text="getUserName" v-if="!isUserLoading"></h1>
    </div>
    <TabContainer :tabs="tabs"/>
    <div class="page-content lighter-shadow" style="margin-bottom: 50px;">
      <div class="tab-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import redirectService from "@/services/redirect.service";
import {mapGetters} from 'vuex';
import TabContainer from "@/shared/components/TabContainer";

export default {
  name: "UserInfo",
  components: {TabContainer},
  created() {
    if (this.$route.path === '/users/' + this.userId) {
      redirectService.redirectToUserInfo(this.userId);
      return;
    }

    this.$store.dispatch('fetchUserById', this.userId);
    this.$store.dispatch('fetchUserRoles');
  },
  data() {
    return {
      userId: this.$route.params.id,
    }
  },
  methods: {},
  computed: {
    ...mapGetters(['selectedUser', 'isUserLoading', 'isSelectedUserAdmin']),

    getUserName() {
      return this.selectedUser.firstName + ' ' + this.selectedUser.lastName;
    },

    tabs() {
      if (this.isSelectedUserAdmin) {
        return [
          {
            id: 'UserInfo',
            link: 'information',
            name: 'Информация',
            icon: 'fa fa-user',
          },
          {
            id: 'UserResetPassword',
            link: 'reset-password',
            name: 'Промяна на парола',
            icon: 'fas fa-key'
          }
        ]
      } else {
        return [
          {
            id: 'UserInfo',
            link: 'information',
            name: 'Информация',
            icon: 'fa fa-user',
          },
          {
            id: 'UserResetPassword',
            link: 'reset-password',
            name: 'Промяна на парола',
            icon: 'fas fa-key'
          },
          {
            id: 'UserTeams',
            link: 'teams',
            name: 'Екипи (права)',
            icon: 'fas fa-sitemap'
          }
        ]
      }
    }
  }
}
</script>

<style scoped>
@import '../../css/shared/tabs.css';

.tab-content {
  width: 100%;
  float: left;
  box-sizing: border-box;
  padding: 25px;
}

</style>
